(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["nx-duo-pack"] && !Shopify.designMode) return;
  try {
    (() => {
    const bind = (duo) => {
      if (duo.dataset.nxBound) return;
      duo.dataset.nxBound = '1';
      const rings = [...duo.querySelectorAll('[data-nx-duo-ring]')];
      const error = duo.querySelector('[data-nx-duo-error]');
      const add = duo.querySelector('[data-nx-duo-add]');
      const pick = (ring, kind) => ring.querySelector(`input[data-kind="${kind}"]:checked`)?.value || '';

      duo.addEventListener('change', () => {
        rings.forEach((r) => r.classList.toggle('is-done', !!(pick(r, 'color') && pick(r, 'size'))));
        if (rings.every((r) => r.classList.contains('is-done'))) {
          duo.classList.remove('is-invalid');
          error.hidden = true;
        }
      });

      add.addEventListener('click', async () => {
        const items = rings.map((r) => ({ color: pick(r, 'color'), size: pick(r, 'size') }));
        if (items.some((i) => !i.color || !i.size)) {
          duo.classList.add('is-invalid');
          error.hidden = false;
          return;
        }
        add.setAttribute('aria-busy', 'true');
        try {
          const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
          const res = await fetch(`${root}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              items: items.map((i) => ({
                id: Number(duo.dataset.variantId),
                quantity: 1,
                properties: { Color: i.color, 'Ring size': i.size, Pack: 'Duo' },
              })),
            }),
          });
          if (!res.ok) throw new Error('add failed');
          window.location.href = `${root}cart`;
        } catch (e) {
          add.removeAttribute('aria-busy');
          error.textContent = 'Something went wrong. Please try again.';
          error.hidden = false;
        }
      });
    };
    const start = () => document.querySelectorAll('[data-nx-duo]').forEach(bind);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["nx-size-whatsapp"] && !Shopify.designMode) return;
  try {
    (() => {
    const bind = (pick) => {
      if (pick.dataset.nxBound) return;
      pick.dataset.nxBound = '1';
      const form = document.getElementById(pick.dataset.formId);
      const groups = [...pick.querySelectorAll('[data-nx-group]')].map((set) => ({
        set,
        radios: [...set.querySelectorAll('input[type="radio"]')],
        error: set.querySelector('[data-nx-pick-error]'),
        shown: set.querySelector('[data-nx-chosen]'),
      }));
      const wa = pick.querySelector('[data-nx-wa="product"]');
      const value = (g) => g.radios.find((r) => r.checked)?.value || '';
      const flag = (g, bad) => {
        g.set.classList.toggle('is-invalid', bad);
        if (g.error) g.error.hidden = !bad;
      };

      const updateWa = () => {
        if (!wa) return;
        let text = (wa.dataset.waTemplate || '').replace('[product]', wa.dataset.productTitle);
        groups.forEach((g) => {
          const v = value(g);
          if (v) text += `\n${g.radios[0].name.replace(/^properties\[|\]$/g, '')}: ${v}`;
        });
        text += `\n${wa.dataset.productUrl}`;
        wa.href = `https://wa.me/${wa.dataset.waNumber}?text=${encodeURIComponent(text)}`;
      };
      updateWa();

      groups.forEach((g) => {
        // The browser blocks submit on its own when a choice is missing; show our message too.
        g.radios.forEach((r) => r.addEventListener('invalid', () => flag(g, true)));
        g.radios.forEach((r) => r.addEventListener('change', () => {
          flag(g, false);
          if (g.shown) g.shown.textContent = value(g);
          // Lets the 3D ring on the page switch to the chosen metal.
          if (/color/i.test(g.radios[0].name)) document.dispatchEvent(new CustomEvent('nx:color', { detail: value(g) }));
          updateWa();
        }));
      });

      // "Use size" on the home page links here with ?size=; pre-select it.
      const preset = new URLSearchParams(window.location.search).get('size');
      if (preset) {
        groups.forEach((g) => {
          const r = g.radios.find((x) => /size/i.test(x.name) && x.value === preset);
          if (r) {
            r.checked = true;
            r.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }

      // Stop add-to-cart until colour and size are picked (capture phase runs before the theme's handler).
      if (form) {
        form.addEventListener('submit', (e) => {
          const missing = groups.filter((g) => !value(g));
          if (!missing.length) return;
          e.preventDefault();
          e.stopImmediatePropagation();
          missing.forEach((g) => flag(g, true));
          missing[0].set.scrollIntoView({ behavior: 'smooth', block: 'center' });
          missing[0].radios[0]?.focus({ preventScroll: true });
        }, true);
      }
    };
    const start = () => document.querySelectorAll('[data-nx-pick]').forEach(bind);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();
  } catch(e) { console.error(e); }
})();

})();
